import { useState, Suspense, lazy } from 'react';
import { DesignSystemTabs } from './DesignSystemTabs';

const ColorsSection = lazy(() =>
  import('./sections/ColorsSection').then((m) => ({ default: m.ColorsSection })),
);
const TypographySection = lazy(() =>
  import('./sections/TypographySection').then((m) => ({ default: m.TypographySection })),
);
const ButtonsSection = lazy(() =>
  import('./sections/ButtonsSection').then((m) => ({ default: m.ButtonsSection })),
);
const BadgesSection = lazy(() =>
  import('./sections/BadgesSection').then((m) => ({ default: m.BadgesSection })),
);
const CardsSection = lazy(() =>
  import('./sections/CardsSection').then((m) => ({ default: m.CardsSection })),
);
const FormsSection = lazy(() =>
  import('./sections/FormsSection').then((m) => ({ default: m.FormsSection })),
);
const FeedbackSection = lazy(() =>
  import('./sections/FeedbackSection').then((m) => ({ default: m.FeedbackSection })),
);
const AvatarsSection = lazy(() =>
  import('./sections/AvatarsSection').then((m) => ({ default: m.AvatarsSection })),
);
const OverlaysSection = lazy(() =>
  import('./sections/OverlaysSection').then((m) => ({ default: m.OverlaysSection })),
);
const DataSection = lazy(() =>
  import('./sections/DataSection').then((m) => ({ default: m.DataSection })),
);
const DomainSection = lazy(() =>
  import('./sections/DomainSection').then((m) => ({ default: m.DomainSection })),
);
const TimelineSection = lazy(() =>
  import('./sections/TimelineSection').then((m) => ({ default: m.TimelineSection })),
);
const ShadcnSection = lazy(() =>
  import('./sections/ShadcnSection').then((m) => ({ default: m.ShadcnSection })),
);

const SectionLoader = () => (
  <div className="flex items-center justify-center py-12">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-cime-primary border-t-transparent" />
  </div>
);

export const DesignSystemPage = () => {
  const [activeTab, setActiveTab] = useState('colors');

  const renderSection = () => {
    switch (activeTab) {
      case 'colors':
        return <ColorsSection />;
      case 'typography':
        return <TypographySection />;
      case 'buttons':
        return <ButtonsSection />;
      case 'badges':
        return <BadgesSection />;
      case 'cards':
        return <CardsSection />;
      case 'forms':
        return <FormsSection />;
      case 'feedback':
        return <FeedbackSection />;
      case 'avatars':
        return <AvatarsSection />;
      case 'overlays':
        return <OverlaysSection />;
      case 'data':
        return <DataSection />;
      case 'domain':
        return <DomainSection />;
      case 'timeline':
        return <TimelineSection />;
      case 'shadcn':
        return <ShadcnSection />;
      default:
        return <ColorsSection />;
    }
  };

  return (
    <div className="main-container-gdm space-y-6">
      <div>
        <h1
          className="text-4xl font-bold text-neutral-900"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Design System
        </h1>
        <p className="text-neutral-500 mt-2 text-sm">
          Bibliothèque de composants CIME Plus — charte graphique cabinet d'avocats
        </p>
      </div>

      <DesignSystemTabs activeTab={activeTab} onTabChange={setActiveTab} />

      <Suspense fallback={<SectionLoader />}>{renderSection()}</Suspense>
    </div>
  );
};
